import { createClassName } from 'utils/createClassName';

import './popupStyles.css';

export const createPopupClassName = createClassName('popup');
